import SortableTree from "@nosferatu500/react-sortable-tree";
import "@nosferatu500/react-sortable-tree/style.css";
import React from "react";
import { GetUserMenusByUserIdResponse } from "../../../models/menu.model";
import TabsEmptyStyle from "./TabsEmptyStyle";

interface Props {
  userMenus: GetUserMenusByUserIdResponse[];
  setUserMenus: any;
}

const Menus = ({ userMenus, setUserMenus }: Props) => {
  return (
    <>
      <div className="menu-tree">
        <SortableTree
          canDrag={() => false}
          treeData={userMenus}
          rowDirection="rtl"
          searchFocusOffset={0}
          onChange={(userMenus) => {
            setUserMenus(userMenus);
          }}
          placeholderRenderer={() => (
            <>
              <TabsEmptyStyle text="منوها" />
            </>
          )}
        />
      </div>
    </>
  );
};

export default Menus;
